<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 년도 -->
          <c-datepicker
            :range="true"
            type="year"
            defaultStart="-1y"
            defaultEnd="0y"
            label="LBLYEAR"
            name="years"
            v-model="searchParam.years"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="stepItems"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            type="none"
            name="heaMuscleSopStepCd"
            label="LBLSTEPPROGRESS"
            v-model="searchParam.heaMuscleSopStepCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :rejectItems="['MSC0000010']"
            type="search"
            codeGroupCd="HEA_SURVEY_CATEGORY_CD"
            itemText="codeName"
            itemValue="code"
            name="heaSurveyCategoryCd"
            label="조사구분"
            v-model="searchParam.heaSurveyCategoryCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="assessResultItems"
            itemText="codeName"
            itemValue="code"
            type="search"
            name="assessResult"
            label="평가결과"
            v-model="searchParam.assessResult"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      title="근골격계 조사 목록"
      :merge="grid.merge"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'hazardInvestigation',
  data() {
    return {
      searchParam: {
        plantCd: null,
        years: [],
        heaMuscleSopStepCd: 'INVEST',
        heaSurveyCategoryCd: null,
        assessResult: null,
      },
      grid: {
        merge: [
          { index: 0, colName: 'heaInvestigationPlanId', },
          { index: 1, colName: 'heaInvestigationPlanId', },
          { index: 2, colName: 'heaInvestigationPlanId', },
          { index: 3, colName: 'heaInvestigationPlanId', },
          { index: 4, colName: 'heaMuscleSopId', },
          { index: 5, colName: 'heaMuscleSopId', },
          { index: 6, colName: 'heaMuscleSopId', },
        ],
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: false,
            style: 'width:100px',
          },
          {
            name: 'investigationPlanName',
            field: 'investigationPlanName',
            label: '조사계획명',
            align: 'left',
            sortable: false,
            style: 'width:180px',
          },
          {
            name: 'year',
            field: 'year',
            label: 'LBLYEAR',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'heaSurveyCategoryName',
            field: 'heaSurveyCategoryName',
            label: '조사구분',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'processName',
            field: 'processName',
            label: 'LBLPROCESS',
            align: 'center',
            sortable: false,
            style: 'width:200px',
          },
          {
            name: 'sopName',
            field: 'sopName',
            label: '단위작업',
            align: 'left',
            sortable: false,
            style: 'width:200px',
            type: 'link'
          },
          {
            name: 'heaMuscleSopStepName',
            field: 'heaMuscleSopStepName',
            label: 'LBLSTEPPROGRESS',
            align: 'center',
            sortable: false,
            style: 'width:100px',
          },
          {
            name: 'heavyWorkName',
            field: 'heavyWorkName',
            label: '부담작업No',
            align: 'center',
            sortable: false,
            style: 'width:90px',
          },
          {
            name: 'unitWorkTime',
            field: 'unitWorkTime',
            label: '단위작업<br/>시간(초)',
            align: 'right',
            sortable: false,
            style: 'width:70px',
            type: 'cost'
          },
          {
            name: 'workTime',
            field: 'workTime',
            label: '노출시간<br/>(초)',
            align: 'right',
            sortable: false,
            style: 'width:70px',
            type: 'cost'
          },
          {
            name: 'workCnt',
            field: 'workCnt',
            label: '노출빈도<br/>(횟수)',
            align: 'right',
            sortable: false,
            style: 'width:70px',
            type: 'cost'
          },
          {
            name: 'exposureWeight',
            field: 'exposureWeight',
            label: '노출취급<br/>중량(kg)',
            align: 'right',
            sortable: false,
            style: 'width:70px',
            type: 'cost'
          },
          {
            name: 'assessResult',
            field: 'assessResult',
            label: '평가결과',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
        ],
        data: [],
      },
      stepItems: [],
      assessResultItems: [
        { code: 'O', codeName: '평가결과 : O', },
        { code: 'X', codeName: '평가결과 : X', },
      ],
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.hea.muscleSystem.muscleSop.invest.list.url
      // code setting
      this.$comm.getStepItems('HEA_MUSCLE_SOP_STEP_CD').then(_result => {
        // 조사중 제외
        _result = this.$_.reject(_result, { stepperMstCd: 'HMS000001', })
        this.stepItems = this.$_.concat([{ stepperMstCd: 'INVEST', stepperMstNm: '전체' }], _result)
      });
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col) {
      this.popupOptions.title = '근골격계 조사계획';
      this.popupOptions.param = {
        heaMuscleSopId: row.heaMuscleSopId,
      };
      this.popupOptions.target = () => import(`${'./hazardInvestigationDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
